<h3>Dashboard</h3>
<div class="grid grid-pad">
  <a *ngFor="let tenant of tenants" class="col-1-4" routerLink="/tenant/{{tenant.id}}">
    {{tenant.name}}
  </a>
</div>
